import { Users, House } from "@phosphor-icons/react";
import { Chapter, Reveal } from "@/components/site/Reveal";

export const About = () => {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-36"
        >
            <Chapter
                index="06"
                label="Our story"
                testid="about-chapter"
                title={
                    <>
                        Locally owned &amp;{" "}
                        <span className="italic text-brand-accent">family operated</span>.
                    </>
                }
            />

            <div className="mx-auto max-w-3xl text-center">
                <Reveal>
                    <p className="font-display text-2xl font-medium leading-snug text-brand-text md:text-4xl">
                        "We're a small, tight-knit crew based right here in the
                        Treasure Valley. Every install is done by our own hands
                        — <span className="italic text-brand-accent">no subcontractors, no shortcuts</span>.
                        Just neighbors building beautiful, low-maintenance
                        yards for other neighbors."
                    </p>
                </Reveal>

                <Reveal delay={0.12}>
                    <div className="mx-auto mt-12 grid max-w-xl grid-cols-2 gap-3">
                        <div
                            data-testid="about-stat-locally-owned"
                            className="rounded-2xl border border-brand-border bg-white p-5 text-left transition-colors duration-500 hover:border-brand-accent/40"
                        >
                            <House
                                size={22}
                                weight="duotone"
                                className="text-brand-accent"
                            />
                            <p className="font-display mt-3 text-xl font-medium text-brand-text">
                                Locally owned
                            </p>
                            <p className="mt-1 text-xs text-brand-muted">
                                Born &amp; based in Idaho
                            </p>
                        </div>
                        <div
                            data-testid="about-stat-family-operated"
                            className="rounded-2xl border border-brand-border bg-white p-5 text-left transition-colors duration-500 hover:border-brand-accent/40"
                        >
                            <Users
                                size={22}
                                weight="duotone"
                                className="text-brand-accent"
                            />
                            <p className="font-display mt-3 text-xl font-medium text-brand-text">
                                Family operated
                            </p>
                            <p className="mt-1 text-xs text-brand-muted">
                                Our crew, every job
                            </p>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
